<template>
    <router-link 
     :is="!enableAIChat && link.name=='AI'  ? 'span' : 'router-link'"
    :to="!enableAIChat && link.name=='AI' ? '' : globalNav===true?link.url:`${relativePath}${link.url}`" exact-path :class="{ disabled: !enableAIChat && link.name=='AI' }">
        <!-- {{  link.name }} / {{  showSearch }} -->
        <!-- <UpgradePlanTooltip 
            type="upgrade-cue"
            :showTooltip="!enableAIChat && link.name=='AI'" 
            title="Unlock AI Wizard"
            :message="'Get to insights 10x faster. Available on the Enterprise plan.'"
            renderedIn="AI Wizard Nav link on Project view"
        > -->
            <!-- <div @mouseenter="hoveredLink=link.name" @mouseleave="hoveredLink=null" @click="trackNavLinkClick(link)" v-if="link.name!='search' || (link.name=='search' && showSearch)" :class="link.name == 'AI' ? 'link-name big-link' : link.name=='search' ? 'pulsating-border link-name':'link-name'"> -->
            <v-hover v-slot="{ hover }">
                <div 
                
                @mouseenter="hoveredLink=link.name" @mouseleave="hoveredLink=null" @click="trackNavLinkClick(link)" v-if="link.name!='search' || (link.name=='search' && showSearch)" :class="link.name == 'AI' ? 'link-name big-link' : link.name=='search' ? 'pulsating-border link-name':'link-name'">

                <!-- <i v-if="link.name==='home'" class="ri-home-line"></i> -->
                <i v-if="link.name==='projects'" class="ri-folder-line"></i>
                <i v-if="link.name==='reels'" class="ri-film-line"></i>
                <i v-if="link.name==='calendar'" class="ri-calendar-event-line"></i>
                <i v-if="link.name==='settings'" class="ri-settings-2-line"></i>
                <i v-if="link.name==='search'" class="ri-search-line"></i>
                
                <span 
                :style="{ opacity: (!enableAIChat && link.name=='AI') ? 0.5 : 1, display:'flex', alignItems:'flex-start', justifyContent:'flex-start'}"
                @click="trackCallsNudge" :class="globalNav ? 'global-nav-link' : 'global-link'">
                <i v-if="link.name==='AI'" class="ri-bard-line"></i>
    
                {{link.name}}
                    <Beacon v-if="showBeacon && link.name =='calls'"/>
                </span>
                <div :style="{ opacity: (!enableAIChat && link.name=='AI') ? 0.5 : 1}" class="beta-tag ml-2" v-if="link.name==='AI'">Beta</div>
                <div v-if="!enableAIChat && hoveredLink=='AI' && hover" class="hovered-link-tooltip">
                    <div class="upgrade-cue-confirmation" v-if="showAIWizardCueConfirmation">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
                        <path d="M24.3442 11.2538C25.3049 11.7244 26.385 11.9886 27.5269 11.9886C28.0231 11.9886 28.5076 11.9387 28.9757 11.8437V27.9252C28.9757 28.7254 28.327 29.374 27.5269 29.374H1.44878C0.648649 29.374 0 28.7254 0 27.9252V4.74468C0 3.94455 0.648649 3.2959 1.44878 3.2959H20.4278C20.3328 3.76401 20.283 4.24852 20.283 4.74468C20.283 6.53642 20.9335 8.17623 22.0112 9.4408L14.5756 15.8755L5.28403 7.98662L3.40867 10.1954L14.5937 19.6919L24.3442 11.2538Z" fill="#D2DCFB"/>
                        <path d="M23.3071 4.74479C23.3071 7.1452 25.253 9.09114 27.6535 9.09114C30.054 9.09114 31.9998 7.1452 31.9998 4.74479C31.9998 2.34437 30.054 0.398438 27.6535 0.398438C25.253 0.398438 23.3071 2.34437 23.3071 4.74479Z" fill="#5B7EDB"/>
                        </svg>
                        <p class="mt-3 mb-1">Thank you for your interest!</p>
                        <p>We’ll send you an email with next <br/>steps.</p>
                    </div>
                    <div v-else>
                        <h3>Unlock AI Wizard
                            <svg @click="handleAIWizardCueLinkClick" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_20649_265105)">
                                <path d="M8.00004 14.6668C4.31804 14.6668 1.33337 11.6822 1.33337 8.00016C1.33337 4.31816 4.31804 1.3335 8.00004 1.3335C11.682 1.3335 14.6667 4.31816 14.6667 8.00016C14.6667 11.6822 11.682 14.6668 8.00004 14.6668ZM8.00004 13.3335C9.41453 13.3335 10.7711 12.7716 11.7713 11.7714C12.7715 10.7712 13.3334 9.41465 13.3334 8.00016C13.3334 6.58567 12.7715 5.22912 11.7713 4.22893C10.7711 3.22873 9.41453 2.66683 8.00004 2.66683C6.58555 2.66683 5.229 3.22873 4.2288 4.22893C3.22861 5.22912 2.66671 6.58567 2.66671 8.00016C2.66671 9.41465 3.22861 10.7712 4.2288 11.7714C5.229 12.7716 6.58555 13.3335 8.00004 13.3335ZM7.33337 4.66683H8.66671V6.00016H7.33337V4.66683ZM7.33337 7.3335H8.66671V11.3335H7.33337V7.3335Z" fill="#B2B2B2"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_20649_265105">
                                <rect width="16" height="16" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </h3>
                        <p>Get to insights 10x faster. Available <br/> on the Enterprise plan.</p>
                        <button @click="toggleAIWizardCue">Contact Us</button>
                    </div>
                </div>

            </div>
        </v-hover>
        <!-- </UpgradePlanTooltip> -->
    </router-link>
</template>

<script>
import Beacon from '../nudges/Beacon.vue'
import { SearchPageEvents } from '@/views/search/events';
import { AIAssistantEvents } from '@/views/assistants/events';
import { auth } from '@/firebase';
import { mapState } from "vuex";
import UpgradePlanTooltip from '@/components/UpgradePlanTooltip.vue';

export default {
    computed: {
      ...mapState([
            "enableAIChat"
        ]),
    },
    props: {
        link: {},
        globalNav:{},
        relativePath:{},
        showBeacon:{
            default: false
        },
        showSearch:{
            default: false
        }
    },
    components: {Beacon, 
        // UpgradePlanTooltip 
    },
    data(){
        return{
            hoveredLink: null,
            showAIWizardCueConfirmation: false
        }
    },
    methods:{
        toggleAIWizardCue(){
            window.analytics.track(`click on Upgrade cue from AI Wizard Nav link on Project view`, {
                    email: auth.currentUser.email,
                });
            this.showAIWizardCueConfirmation = true
        },
        handleAIWizardCueLinkClick(){
            window.open('https://help.looppanel.com/en/articles/11010059-how-to-use-ai-wizard-on-looppanel', '_blank')
        },
        trackCallsNudge(){
            if(!this.enableAIChat){
                return
            }
            this.$emit('track-calls-nudge')
        },
        trackNavLinkClick(link){
            if(link.name == 'search'){
                window.analytics.track(SearchPageEvents.OPEN_SEARCH.event, {
                    email: auth.currentUser.email,
                })
            }

            if(link.name == 'AI'){
                if(!this.enableAIChat){
                    return
                }
                window.analytics.track(AIAssistantEvents.OPEN_AI_ASSISTANT.event, {
                    email: auth.currentUser.email,
                })
            }
        }
    }
}
</script>

<style scoped>

    .global-link{
        display: flex;
        align-items: center;
    }
    .link-name{
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        /* identical to box height, or 21px */
        text-transform: capitalize;
        /* Neutrals/300 */
        color: #666666;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 12px 16px;
        /* width: 96px; */
        height: 37px; 
        min-width: 86px;
        /* Primary/200 */
        /* background: #F6F8FE; */
        border-radius: 33px;
        margin-right: 12px;
        white-space: nowrap;
        position: relative;
    }

    .big-link{
        width: 105px;
    }

    .beta-tag{
        /* position: absolute;
        right: 0%;
        top: 22%; */
        display: flex;
        padding: 2px 8px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border-radius: 28px;
        background: var(--Primary-400, #D2DCFB);
        color: var(--Primary-500, #5B7EDB);
        font-family: Inter;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 15px */
        letter-spacing: 0.5px;
        text-transform: uppercase !important;
    }

    .link-name span{
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 150%;
        /* identical to box height, or 21px */
        text-transform: capitalize;
        /* Neutrals/300 */
        color: #666666; 
    }

    .link-name:hover {
        background: #F8F8F8;
    }

    .link-name i{
        margin-right: 5px;
    }

    .router-link-active .link-name,.router-link-active .link-name.link-name.gradient{
        background: #F6F8FE;
        border-radius: 33px;
        color: #5B7EDB !important;
    }

    .router-link-active .link-name span{
        color: #5B7EDB !important;
        font-weight: 600;
    }

    .router-link-active .link-name.link-name.gradient{
        -webkit-text-fill-color: rgba(125, 68, 219, 0.9);
    }

    .link-name.gradient{
        background:  linear-gradient(90deg, rgba(125, 68, 219, 0.9) -3.45%, rgba(91, 126, 219, 0.9) 99.14%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    /* For this screen size we'll hide the links name and only display it's icon to squeeze some space for recording UI */
    @media only screen and (min-width:800px) and (max-width: 1120px) {
        .global-nav-link{
            display: none;
        }

        .link-name{
            padding: 13px !important;
            width: 45px !important;
            
        }

        .link-name i{
            margin-right: 0px !important;
        }
    }

    .hovered-link-tooltip{
        position: absolute;
        top: 35px;
        left: -40%;
        display: flex;
        width: 268px;
        height: 136px;
        padding: 14px 16px 16px 18px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        border-radius: 8px;
        border: 1px solid var(--Primary-300, #E8EDFC);
        background: var(--Neutrals-White, #FFF);
    }

    .hovered-link-tooltip h3{
        color: var(--Primary-500, #5B7EDB);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%; /* 19.6px */
        display: flex;
    }

    .hovered-link-tooltip h3 svg{
        margin-left: 4px;
        cursor: pointer;
    }

    .hovered-link-tooltip div p{
        color: var(--Neutrals-600, #4C4C4C);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 19.6px */
    }
    .hovered-link-tooltip div button{
        display: flex;
        padding: 4px 12px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border-radius: 32px;
        background: var(--Primary-500, #5B7EDB);
        color: var(--Neutrals-White, #FFF);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 18px */
        text-transform: capitalize;
        cursor: pointer;
    }
    .v-tooltip__content {
        pointer-events: auto;
    }
 .hovered-link-tooltip .upgrade-cue-text{
  color: var(--Neutrals-600, #4C4C4C);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
}
.hovered-link-tooltip .upgrade-cue-confirmation>p{
  color: var(--Neutrals-600, #4C4C4C);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
  text-transform: none;
}
.hovered-link-tooltip .upgrade-cue-confirmation p+p{
  color: var(--Neutrals-600, #4C4C4C);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  text-transform: none;

}
</style>